import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'semantic-ui-react';

const himsMsgIncomplete = 'The given data was invalid.';
const himsDefaultErrorStatus422 = 'The data provided cannot be accepted as valid. Please review and verify the information to ensure its accuracy and reliability. If the problem persists, please report your problem to support@mhub.my and mention this error message.';
const himsDefaultErrorCode9 = 'The permit for this project has been canceled. Kindly seek clarification from HIMS for further details.';

export default class HimsErrorLog extends Component {
  static propTypes = {
    httpStatus: PropTypes.number,
    action: PropTypes.string,
    response: PropTypes.shape({
      status_code: PropTypes.number,
      message: PropTypes.string,
    }),
    errors: PropTypes.arrayOf(PropTypes.string),
  }

  getHimsNewBuyer = (statusCode) => {
    switch (statusCode) {
      case 5:
        return 'Please set the formula in Pricing Package for Bumi Discount category (Diskaun Kuota Bumi) as the value cannot be RM 0.00';
      case 6:
        return 'The SPJB Price (SPA price) surpasses the approved sales price in HIMS. Please verify both the SPA price and the approved price in HIMS to ensure it remains within the approved sales price limit.';
      case 7:
        return 'This unit has already been sold in HIMS, and your request could not be processed through MHub. Please review the unit information in HIMS for further clarification.';
      case 8:
        return 'This unit has been registered for land owner in HIMS, and your request could not be processed through MHub. Please review the unit information in HIMS for further clarification.';
      default:
        return himsDefaultErrorStatus422;
    }
  }

  getHimsDeleteBuyer = (statusCode) => {
    switch (statusCode) {
      case 7:
        return 'This buyer are not allowed to delete using this API. Please submit your cancellation via HIMS.';
      case 8:
        return 'This purchaser is considered as First Buyer in HIMS, and your request could not be processed through MHub. Please submit your application Pembatalan Pembeli Pertama via HIMS.';
      default:
        return himsDefaultErrorStatus422;
    }
  }

  getHimsSuggestion = () => {
    const { httpStatus, action, response } = this.props;
    if (!response) {
      return '';
    }
    const { message, status_code: statusCode } = response;
    switch (httpStatus) {
      case 401:
        return 'The request is denied due to an authentication error. If the problem persists, please report your problem to support@mhub.my and mention this error message and the query that caused it.';
      case 404:
        return 'The server encountered an error and could not complete your request. If the problem persists, please report your problem to support@mhub.my and mention this error message and the query that caused it.';
      case 422:
        if (statusCode === 9) {
          return himsDefaultErrorCode9;
        }
        switch (action) {
          case 'new_buyer':
            return this.getHimsNewBuyer(statusCode);
          case 'delete_buyer':
            return this.getHimsDeleteBuyer(statusCode);
          case 'change_buyer':
            if (message.startsWith('Permission denied!')) {
              return this.getHimsDeleteBuyer(statusCode);
            }
            return this.getHimsNewBuyer(statusCode);
          default:
            return himsDefaultErrorStatus422;
        }
      case 500:
        return 'The server encountered an error and could not complete your request. If the problem persists, please report your problem to support@mhub.my and mention this error message and the query that caused it.';
      default:
        return '';
    }
  }

  getErrorItems = () => {
    const { errors, response } = this.props;
    let errMessage = himsMsgIncomplete;
    if (response && response.message) {
      errMessage = response.message;
    }

    if (errMessage === himsMsgIncomplete) {
      return errors.filter(d => d !== himsMsgIncomplete).map((d, idx) => <List.Item key={`hims_error_${idx}`}>{d}</List.Item>);
    }
    return [];
  }

  renderHeader = () => {
    const { httpStatus, response } = this.props;
    let header = 'Incomplete required information';
    if (response && response.message) {
      header = `${httpStatus} ${response.message}`;
    }
    return <h3>Error: {header}</h3>;
  }

  render() {
    const suggestion = this.getHimsSuggestion();
    const errorItems = this.getErrorItems();
    return (
      <div>
        {this.renderHeader()}
        {suggestion && <p>{suggestion}</p>}
        {errorItems.length > 0 && <p>Please complete the information below:</p>}
        {errorItems.length > 0 && <List bulleted>{errorItems}</List>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HimsErrorLog.jsx